// extracted by mini-css-extract-plugin
export default {"wrapper":"EditOrganizationForm_wrapper__nH7Ld","submitWrapper":"EditOrganizationForm_submitWrapper__1h+-x"};